<template>
  <div class="container">
    <el-container>
      <el-header class="header" height="13vh">
        <div class="header__title">
          <label>{{ columnItemContent.title }}</label>
        </div>
        <div class="header__time">
          <label>{{ columnItemContent.createTime }}</label>
        </div>
      </el-header>
      <el-main class="main">
        <div class="main-content">
          <div v-if="getContentType === 'image'" ref="imgContent">
          </div>
          <div v-if="getContentType === 'pdf'" ref="pdfContent">
          </div>
          <div v-if="getContentType === 'mp4'" ref="videoContent">
            <video @loadstart="closeLoading"
                   @error="loadError" ref="videoPlayer" class="video-js vjs-default-skin video" controls>
            </video>
          </div>
          <div v-if="columnItemContent.nextItem || columnItemContent.previousItem" class="main-content__footer"
               ref="mainContentFooter">
            <div v-if="columnItemContent.previousItem" class="main-content-footer__item next" @click="handlerPrevItem">
              <label class="item_label">上一篇</label>
              <label>{{ columnItemContent.previousItem.title }}</label>
            </div>
            <div v-if="columnItemContent.nextItem" class="main-content-footer__item prev" @click="handlerNextItem">
              <label class="item_label">下一篇</label>
              <label>{{ columnItemContent.nextItem.title }}</label>
            </div>
          </div>
        </div>
      </el-main>
      <el-footer class="footer" height="4vh">
        <label>阅读 {{ columnItemContent.readQuantity }}</label>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import columnItemUtil from "@/utils/CollumnItemUtil";
import * as pdfjsLib from 'pdfjs-dist';
import 'pdfjs-dist/build/pdf.worker.entry';
import fileUtils from "@/utils/FileUtils";
import videojs from 'video.js';

export default {
  name: "ColumnItemContent",
  data() {
    return {
      columnItemContent: {},
      loadInstance: null,
      fit: 'contain',
      init: false,
    };
  },
  methods: {
    handlerPrevItem() {
      this.clearAllContainer();
      const prev = this.columnItemContent.previousItem;
      if (!prev) {
        return false;
      }
      columnItemUtil.incrementReadQuantity(prev);

      if (prev.contentLink) {
        if (window.miniprogram) {
          this.columnItemContent = prev;
        } else {
          window.location.href = prev.contentLink
        }
      } else {
        this.columnItemContent = prev;
      }
    },
    handlerNextItem() {
      this.clearAllContainer();
      const next = this.columnItemContent.nextItem;
      if (!next) {
        return false;
      }
      columnItemUtil.incrementReadQuantity(next);
      if (next.contentLink) {
        if (window.miniprogram) {
          this.columnItemContent = next;
        } else {
          window.location.href = next.contentLink
        }
      } else {
        this.columnItemContent = next;
      }
    },
    contentLoading(text) {
      text = text || '加载中...';
      this.closeLoading();
      this.loadInstance = this.$loading({
        lock: true,
        text: text,
        fullscreen: false,
      });
    },
    closeLoading() {
      if (this.loadInstance) {
        this.loadInstance.close();
        this.loadInstance = null;
      }
    },
    loadError(text) {
      text = text || '资源加载失败';
      if (this.loadInstance) {
        this.loadInstance.close();
        this.loadInstance = null;
      }

      // this.$message({
      //   message: text,
      //   duration: 1500,
      //   type: "error",
      //   onClose: () => {
      //     this.$router.back();
      //   }
      // });
    },
    clearBeforeLoad(item) {
      if (item) {
        let childElementCount = item.childElementCount;
        for (let i = 0; i < childElementCount; i++) {
          item.firstChild.remove();
        }
      }
    },
    clearAllContainer() {
      this.clearBeforeLoad(this.$refs.imgContent);
      this.clearBeforeLoad(this.$refs.pdfContent);
      this.clearBeforeLoad(this.$refs.videoContent);
    },
    scrollToTop() {
      document.querySelector('.main-content').scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    },
    loadContent() {
      this.disposeVideo();
      try {
        fileUtils.load(this.columnItemContent.contentFilePath).then(arrayBuffer => {
          const blob = new Blob([arrayBuffer], {type: this.getMediaType});
          this.columnItemContent.fileUrl = URL.createObjectURL(blob);
          this.init = true;
          let contentType = this.getContentType;
          if (contentType === 'pdf') {
            const loadingTask = pdfjsLib.getDocument({
              // url: this.columnItemContent.contentFileAbsolutePath,
              url: this.columnItemContent.fileUrl,
            });
            const devicePixelRatio = window.devicePixelRatio || 1;
            loadingTask.promise.then(pdfDoc => {
              for (let i = 1; i <= pdfDoc.numPages; i++) {
                pdfDoc.getPage(i).then(page => {
                  const canvas = document.createElement('canvas');
                  canvas.style.width = '100%';
                  canvas.height = page.getViewport({scale: devicePixelRatio}).height;
                  canvas.width = page.getViewport({scale: devicePixelRatio}).width;
                  const ctx = canvas.getContext('2d');
                  page.render({
                    canvasContext: ctx,
                    viewport: page.getViewport({scale: devicePixelRatio}),
                  });
                  // 添加到第一个容器中
                  this.$refs.pdfContent.appendChild(canvas);
                }).catch(error => {
                  console.error('pdf加载失败', error);
                  this.loadError();
                });
              }
              this.closeLoading();
              this.scrollToTop();
            });
          } else if (contentType === 'image') {
            const img = new Image();
            // img.src = this.columnItemContent.contentFileAbsolutePath;
            img.src = this.columnItemContent.fileUrl;
            img.onload = () => {
              const canvas = document.createElement('canvas');
              canvas.style.width = '100%';
              canvas.width = img.width;
              canvas.height = img.height;
              const ctx = canvas.getContext('2d');
              ctx.drawImage(img, 0, 0, img.width, img.height)
              this.$refs.imgContent.appendChild(canvas);
              this.closeLoading();
              this.scrollToTop();
            };
            img.onerror = () => {
              console.error('图片加载失败');
              this.loadError();
            };
          } else {
            this.player = videojs(this.$refs.videoPlayer, {
                autoplay: false, // iOS 需用户交互后播放
                // 显示控制条
                controls: true,
                sources: [{
                  src: this.columnItemContent.fileUrl,
                  type: 'video/mp4',
                }],
                width: '100%',
                height: '100%',
                // 流体模式（自适应容器）
                fluid: true,
              },
              () => {
                this.closeLoading();
              }
            );
          }
        });
      } catch (e) {
        console.error('加载失败', e);
        this.loadError(e);
      }
    },
    loadContentByAbsolutePath() {
      this.disposeVideo();
      this.init = true;
      let contentType = this.getContentType;
      const contentFileAbsolutePath = this.columnItemContent.contentFileAbsolutePath;
      if (contentType === 'pdf') {
        const loadingTask = pdfjsLib.getDocument({
          url: contentFileAbsolutePath,
        });
        let devicePixelRatio = window.devicePixelRatio || 1;
        loadingTask.promise.then(pdfDoc => {
          for (let i = 1; i <= pdfDoc.numPages; i++) {
            pdfDoc.getPage(i).then(page => {
              const canvas = document.createElement('canvas');
              const viewport = page.getViewport({scale: devicePixelRatio * 1.5});
              canvas.style.width = '100%';
              canvas.style.height = `auto`;
              canvas.width = viewport.width ;
              canvas.height = viewport.height;
              const ctx = canvas.getContext('2d');
              page.render({
                canvasContext: ctx,
                viewport: viewport,
              });
              // 添加到第一个容器中
              this.$refs.pdfContent.appendChild(canvas);
            }).catch(error => {
              console.error('pdf加载失败', error);
              this.loadError();
            });
          }
          this.closeLoading();
          this.scrollToTop();
        });
      } else if (contentType === 'image') {
        const img = new Image();
        img.src = contentFileAbsolutePath;
        // img.src = this.columnItemContent.fileUrl;
        img.onload = () => {
          const canvas = document.createElement('canvas');
          canvas.style.width = '100%';
          canvas.width = img.width;
          canvas.height = img.height;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0, img.width, img.height)
          this.$refs.imgContent.appendChild(canvas);
          this.closeLoading();
          this.scrollToTop();
        };
        img.onerror = () => {
          console.error('图片加载失败');
          this.loadError();
        };
      } else {
        this.player = videojs(this.$refs.videoPlayer, {
            autoplay: false, // iOS 需用户交互后播放
            // 显示控制条
            controls: true,
            sources: [{
              src: contentFileAbsolutePath,
              type: 'video/mp4',
            }],
            width: '100%',
            height: '100%',
            // 流体模式（自适应容器）
            fluid: true,
          },
          () => {
            this.closeLoading();
          }
        );
      }
    },
    disposeVideo() {
      if (this.player) {
        this.player.dispose();
        this.player = null;
      }
    },

  },
  mounted() {
    this.columnItemContent = this.$route.params.columnItemContent;
  },
  beforeDestroy() {
    this.closeLoading();
    this.disposeVideo();
  },
  watch: {
    'columnItemContent'(val) {
      this.$nextTick(() => {
        this.init = false;
        this.contentLoading(this.getLoadingText);
        // this.loadContent();
        this.loadContentByAbsolutePath();
      });
    },
  },
  computed: {
    getContentType() {
      if (this.columnItemContent.contentFilePath?.endsWith('.pdf')) {
        return 'pdf'
      } else if (this.columnItemContent.contentFilePath?.endsWith('.mp4')) {
        return 'mp4'
      } else {
        return 'image'
      }
    },
    getMediaType() {
      if (this.columnItemContent.contentFilePath?.endsWith('.pdf')) {
        return 'application/pdf'
      } else if (this.columnItemContent.contentFilePath?.endsWith('.mp4')) {
        return 'application/octet-stream'
      } else {
        return 'image/*';
      }
    },
    getLoadingText() {
      if (this.columnItemContent.contentFilePath?.endsWith('.pdf')) {
        return '资源加载中...'
      } else if (this.columnItemContent.contentFilePath?.endsWith('.mp4')) {
        return '视屏加载中，请耐心等待...'
      } else {
        return '资源加载中...'
      }
    }
  },
}
</script>

<style scoped>

.container {
  background-color: var(--main-back-color);
  display: flex;
  justify-content: center;
  height: 100vh;
  box-sizing: border-box;
}

::v-deep .el-container {
  max-width: 667px;
  gap: 1rem;
}

.header {
  padding: 20px;
}

.header__title {
  font-size: 1.3rem;
}

.header__time {
  padding: 1rem .5rem;
  text-align: right;
  color: rgb(0, 0, 0, 0.3);
}

.main-content {
  width: 100%;
  height: 100%;
  overflow-y: auto;
}

.main-content__footer {
  display: flex;
  justify-content: space-around;
  align-items: center;
  box-sizing: border-box;
  margin-top: 2rem;
  color: rgba(2, 8, 96, 0.6);
}

.main-content-footer__item {
  width: 40%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 20px 0;
  box-sizing: border-box;
}

.main-content-footer__item:hover, .main-content-footer__item > label:hover {
  cursor: pointer;
}

.item_label {
  box-sizing: border-box;
  padding-right: .5rem;
}

.video {
  width: 100%;
  height: auto;
}

.footer {
  color: rgb(0, 0, 0, 0.3);
  font-size: .9rem;
  margin: auto 0;
}

::v-deep .vue-office-pdf-wrapper {
  background: var(--main-back-color) !important;
}

::v-deep .vue-office-pdf-wrapper > canvas {
  width: 100% !important;
}

::v-deep .vue-office-pdf-wrapper > canvas:first-of-type {
  top: 0px !important;
}

::v-deep .vue-office-pdf-wrapper {
  box-sizing: border-box !important;
}

::v-deep .vjs-fluid:not(.vjs-audio-only-mode) {
  padding-top: 56.25% !important;
}

.pdf-view {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  border: none;
  box-sizing: border-box;
  /* iframe 关闭滚动条 */
}


::-webkit-scrollbar {
  display: none;
}
</style>
